import { InputAdornment, INumberInputProps, NumberInput } from '@cian/ui-kit';
import * as React from 'react';

import { IAreaPartInputProps } from './types';

import styles from './AreaPartInput.css';

const AreaPartInputInner: React.FC<IAreaPartInputProps> = props => {
  const {
    value,
    maxWidth,
    rightAdornment,
    onChange,
    name,
    id,
    invalid,
    dimensionTitle,
    maxValue,
    minValue,
    decimalDigits,
  } = props;

  const handleChange = React.useCallback<NonNullable<INumberInputProps['onChange']>>(
    value => {
      // при задании пустого значения ставим его в null вместо undefined,
      //undefined значение соответствует отсутствию поля в целом, например "этаж по" с отжатой галочкой
      const selectedValue = value !== undefined ? value : null;
      onChange(name, selectedValue);
    },
    [name, onChange],
  );

  const inputName = React.useMemo(() => `areaParts.${id}.${name}`, [id, name]);

  return (
    <div className={styles['container']}>
      <div className={styles['input']}>
        <NumberInput
          invalid={invalid}
          name={inputName}
          maxWidth={maxWidth}
          min={minValue}
          value={value}
          size="XS"
          onChange={handleChange}
          rightAdornment={rightAdornment && <InputAdornment>{rightAdornment}</InputAdornment>}
          max={maxValue}
          decimalDigits={decimalDigits}
        />
        {dimensionTitle && (
          <div className={styles['dimension-title']}>
            <InputAdornment>{dimensionTitle}</InputAdornment>
          </div>
        )}
      </div>
    </div>
  );
};

export const AreaPartInput = React.memo(AreaPartInputInner);
